<template>
  <Flow
    transition-group-class-name="page-modal page-modal--page modal modal--page container-fluid"
    role="dialog"
    :has-flow-container="false"
  >
    <slot />
  </Flow>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick, onMounted, onBeforeUnmount } from 'vue';
import Flow from '@/src/components/Flow/Flow.vue';
import { getScrollbarWidth } from '@/src/utilities/Utilities';
import useDevice from '@/src/hooks/useDevice';
import { useUtilityStore } from '@/src/store/utility';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'UIModal',
  components: { Flow },
  setup() {
    const route = useRoute();
    const utilityStore = useUtilityStore();
    const showPopover = ref(true);
    const scrollbarWidth = getScrollbarWidth();

    onMounted(async () => {
      utilityStore.addBodyClass('site--popover-active');

      document.body.style.overflow = 'hidden';
      await nextTick();
      showPopover.value = true;

      const { isMobile, isTablet } = useDevice();
      const siteEditorViewer = document.querySelector('.site-editor__viewer');

      if (isMobile || isTablet) {
        siteEditorViewer?.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }

      if (route.query && !route.query.edit) {
        const campaignElement = document.querySelector<HTMLElement>('.campaign');

        if (campaignElement) {
          campaignElement.style.paddingRight = `${scrollbarWidth}px`;
        }
      }
    });

    onBeforeUnmount(() => {
      utilityStore.removeBodyClass('site--popover-active');
      document.body.style.overflow = '';
    });

    return {
      showPopover
    };
  }
});
</script>

<style lang="scss" scoped>
.page-modal {
  position: fixed;
  z-index: 1060;
  width: 100%;
  height: 100%;
  display: block;
  background-color: transparent !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch !important;
  transform: translate(0, 0);
  > .section {
    min-height: 100%;
    position: relative !important;
    overflow: hidden;
  }
}

.site--editmode-on {
  .page-modal {
    .section {
      width: auto !important;
    }
  }
}
</style>
